import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import ModalSimplePanel from 'Douleutaras/components/modals/ModalSimplePanel';
import RegularButton from 'Douleutaras/components/RegularButton/RegularButton';
import { buildUrl, VALID_URLS } from 'Douleutaras/utilities/url-builder';
import { POST_JOB_FLOW } from 'Douleutaras/views/job/post-job/types';

import './ExtraBidModal.scss';

export const ExtraBidModal = ({ url, proId, closeButtonCallback }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(buildUrl(VALID_URLS.JOB_DONE, location.state.jobId), {
      state: {
        proId,
        flow: POST_JOB_FLOW.EXTRA_BID,
        autoDealId: location.state.autoDealId,
        bidsCount: location.state.bidsCount,
        requestExtraBids: true
      }
    });
  };

  return (
    <ModalSimplePanel showHead sizeAuto closeCallback={closeButtonCallback}>
      <div styleName="extra-bid-modal__inner">
        <div styleName="extra-bid-modal__image-wrapper">
          <img styleName="extra-bid-modal__image" src={url} alt="" />
          <div styleName="extra-bid-modal__image-icon"><span className="dashicon dashicon-plus" /></div>
        </div>
        <div styleName="extra-bid-modal__content-wrapper">
          <div styleName="extra-bid-modal__content-title">{t('T.EXTRA-BID.MODAL.TITLE')}</div>
          <div styleName="extra-bid-modal__content-text">{t('T.EXTRA-BID.MODAL.TEXT')}</div>
        </div>
        <div styleName="extra-bid-modal__footer-wrapper">
          <RegularButton modifier="primary"
                         size="large"
                         onClick={handleRedirect}
                         title={t('T.EXTRA-BID.MODAL.ACTION-POSITIVE')}
          />
          <RegularButton modifier="primary-no-line"
                         size="large"
                         onClick={closeButtonCallback}
                         title={t('T.EXTRA-BID.MODAL.ACTION-NEGATIVE')}
          />
        </div>
      </div>
    </ModalSimplePanel>
  );
};
